<template>
  <div class="flex items-center">
    <template v-if="channel_info">
      <template v-if="channel_info.live">
        <icon name="preview" class="flex-shrink-0 w-4 h-4 fill-indigo-900 mr-2 align-middle" />
              Streaming: [{{ channel_info.game }}]: {{ channel_info.title }}
        </template>
        <template v-else>
            <icon name="preview" class="flex-shrink-0 w-4 h-4 fill-indigo-300 mr-2 align-middle" />
          Elspeth is currently not live.
        </template>
    </template>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import useTwitch from '@/Shared/useTwitch'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      twitchApi: null,
    }
  },
  created() {
    this.twitchApi = useTwitch()
    if (!this.twitchApi.state.channel) this.twitchApi.fetchChannel()
  },
  computed: {
    channel_info() {
      return (this.twitchApi && this.twitchApi.state.channel) 
    },
  },
}
</script>
